import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as pagesTranslationsActions from "../pageTranslations/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";

import PagesLists from "./pagesLists";
import Forms from "./forms";
const feature = "pagesLists";

const InitialState = Record({
  forms: new Forms(),
  pagesLists: new PagesLists()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function PagesReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  //if (isApiCall(action.type)) {
  //if (action.payload && action.payload.entities && action.payload.entities.pagesLists) {
  //state = state.updateIn(['pagesLists', 'entities'], map => map.mergeDeep(action.payload.entities.pagesLists));
  //}
  //}

  switch (action.type) {
    case actions.GET_PAGES_LISTS + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.GET_PAGES_LISTS + SUCCESS: {
      state = state.setIn(
        ["pagesLists", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["pagesLists", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["pagesLists", "entities"], map =>
        map.mergeDeep(action.payload.entities.pagesLists));
      state = state.setIn(
        ["pagesLists", "results"],
        action.payload.result.pagesLists
      );
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.GET_PAGES_LISTS + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.GET_PAGES_LIST + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.GET_PAGES_LIST + SUCCESS: {
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.GET_PAGES_LIST + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.GET_PAGES_LIST_BY_SLUG + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.GET_PAGES_LIST_BY_SLUG + SUCCESS: {
      state = state.setIn(
        ["pagesLists", "singleListMeta", "all"],
        action.payload.entities.pagesLists[action.payload.result].meta.all
      );
      state = state.setIn(
        ["pagesLists", "singleListMeta", "count"],
        action.payload.entities.pagesLists[action.payload.result].meta.count
      );
      state = state.deleteIn([
        "pagesLists",
        "entities",
        action.payload.result,
        "pages"
      ]);
      state = state.updateIn(["pagesLists", "entities"], map =>
        map.mergeDeep(action.payload.entities.pagesLists));
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.GET_PAGES_LIST_BY_SLUG + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.GET_PAGES_LIST_BY_SLUG_FILMS + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.GET_PAGES_LIST_BY_SLUG_FILMS + SUCCESS: {
      state = state.setIn(
        ["pagesLists", "singleListMetaFilms", "all"],
        action.payload.entities.pagesLists[action.payload.result].meta.all
      );
      state = state.setIn(
        ["pagesLists", "singleListMetaFilms", "count"],
        action.payload.entities.pagesLists[action.payload.result].meta.count
      );
      state = state.deleteIn([
        "pagesLists",
        "entitiesFilms",
        action.payload.result,
        "pages"
      ]);
      state = state.updateIn(
        ["pagesLists", "entitiesFilms"],
        map => map.mergeDeep(action.payload.entities.pagesLists)
      );
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.GET_PAGES_LIST_BY_SLUG_FILMS + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.POST_PAGES_LISTS + START: {
      return disableForm(state, "createPagesList");
    }
    case actions.POST_PAGES_LISTS + SUCCESS: {
      state = clearForm(state, "createPagesList", Forms);
      return enableForm(state, "createPagesList");
    }
    case actions.POST_PAGES_LISTS + ERROR: {
      state = enableForm(state, "createPagesList");
      return setFormErrors(state, "createPagesList", action.payload.errors);
    }

    case actions.PATCH_PAGES_LIST + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.PATCH_PAGES_LIST + SUCCESS: {
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.PATCH_PAGES_LIST + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.DELETE_PAGES_LIST + START: {
      return state.deleteIn(["pagesLists", "entities", action.payload.uid]);
    }

    case actions.SET_PAGE_LIST_PAGINATION_PAGE: {
      return state.setIn(
        ["pagesLists", "singleListMeta", "currentPage"],
        action.payload.page
      );
    }
    case actions.RESET_PAGE_LIST_PAGINATION: {
      state = state.setIn(["pagesLists", "singleListMeta", "all"], 0);
      state = state.setIn(["pagesLists", "singleListMeta", "count"], 0);
      return state.setIn(["pagesLists", "singleListMeta", "currentPage"], 0);
    }
    case actions.GET_PAGES_LIST_CATEGORIES + START: {
      return state.setIn(["pagesLists", "loading"], true);
    }
    case actions.GET_PAGES_LIST_CATEGORIES + SUCCESS: {
      state = state.setIn(
        ["pagesLists", "entities", action.meta.slug, "categories"],
        action.payload.result.categories
      );
      return state.setIn(["pagesLists", "loading"], false);
    }
    case actions.GET_PAGES_LIST_CATEGORIES + ERROR: {
      return state.setIn(["pagesLists", "loading"], false);
    }

    case actions.POST_PAGES_LIST_CATEGORIES + START: {
      return disableForm(state, "createPagesListCategory");
    }
    case actions.POST_PAGES_LIST_CATEGORIES + SUCCESS: {
      state = clearForm(state, "createPagesListCategory", Forms);
      return enableForm(state, "createPagesListCategory");
    }
    case actions.POST_PAGES_LIST_CATEGORIES + ERROR: {
      state = enableForm(state, "createPagesListCategory");
      return setFormErrors(
        state,
        "createPagesListCategory",
        action.payload.errors
      );
    }

    case actions.SET_IS_ADD_PAGES_LIST_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createPagesList", "isAddModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_REMOVE_PAGES_LIST_MODAL_VISIBLE: {
      return state.setIn(
        ["pagesLists", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_EDIT_PAGES_LIST_MODAL_VISIBLE: {
      return state.setIn(
        ["pagesLists", "isEditModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_ADD_PAGES_LIST_CATEGORY_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createPagesListCategory", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_SUCCESS: {
      return state.setIn(
        ["pagesLists", "entities", action.meta.slug, "pages", action.meta.uid],
        fromJS(action.payload.entities.pageTranslations[action.payload.result])
      );
    }

  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/pagesLists/reducer.js